import React, { FunctionComponent, ReactElement } from 'react';
import CheckBox from '@liveramp/motif/core/Checkbox';
import styles from './styles.module.scss';

interface Props {
  text: string;
  Icon: () => ReactElement;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const StatusOption: FunctionComponent<Props> = ({
  text,
  Icon,
  checked,
  onChange
}) => (
  <span className={styles.optionContainer}>
    <CheckBox
      data-test-id={`status-${text}-filter-checkbox`}
      checked={checked}
      onChange={onChange}
      id={`checkbox-${text}`}
    />
    <label
      data-test-id={`status-${text}-filter-checkbox-label`}
      htmlFor={`checkbox-${text}`}
      className={styles.labelForCheckbox}
    >
      <Icon />
      <p>{text}</p>
    </label>
  </span>
);

export default StatusOption;
